import { MenuOutlined } from '@ant-design/icons';
import { Button, Drawer, Grid } from 'antd';
import * as React from 'react';
import { Link } from 'react-router-dom';

import Logo from '../../assets/logo-with-slogan.png';
import { CustomRouteProps } from '../../pages/routes';

import styles from './Header.module.less';
import { HeaderMenu } from './components';

export interface HeaderProps {
  items: Array<CustomRouteProps>;
  onLogout?: () => Promise<void>;
}

export const Header = React.memo(({ items, onLogout }: HeaderProps) => {
  const breakpoints = Grid.useBreakpoint();
  const [visible, setVisible] = React.useState(false);

  const onDrawerClose = () => {
    setVisible(false);
  };

  const onDrawerOpen = () => {
    if (!breakpoints.lg) setVisible(true);
  };

  return (
    <>
      <Link className="brand" to="/">
        <img src={Logo} alt="yousmile" />
      </Link>

      {breakpoints.lg ? (
        <HeaderMenu mode="horizontal" items={items} onLogout={onLogout} />
      ) : (
        <>
          <Button className={styles.drawerToggle} icon={<MenuOutlined />} onClick={onDrawerOpen} />
          <Drawer closable={false} visible={visible} onClose={onDrawerClose}>
            <HeaderMenu mode="inline" items={items} onLogout={onLogout} />
          </Drawer>
        </>
      )}
    </>
  );
});
